import React from 'react';
import { useTranslation } from 'react-i18next';
import './CarePage.css';

export default function CarePage() {
    const { t } = useTranslation();

    return (
        <div className="care-page-container">
            {/* Hero Banner */}
            <section className="care-hero-banner">
                <div className="care-hero-text">
                    <h1>{t('care.title')}</h1>
                    <p>{t('care.subtitle')}</p>
                </div>
                <div className="care-hero-image">
                    <img 
                        src="/images/care-page-image.jpg"
                        alt={t('care.heroAlt')}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/images/care-page-image.jpg";
                        }}
                    />
                </div>
            </section>

            {/* Care Introduction */}
            <section className="care-intro">
                <div className="care-intro-content">
                    <h2>{t('care.introTitle')}</h2>
                    <p>{t('care.introParagraph1')}</p>
                    <p>{t('care.introParagraph2')}</p>
                </div>
            </section>

            {/* Care Instructions */}
            <section className="care-instructions">
                <h2>{t('care.instructionsTitle')}</h2>
                
                <div className="care-instructions-grid">
                    {/* Daily Care */}
                    <div className="care-instruction-card">
                        <div className="care-instruction-icon">
                            <i className="fas fa-sun"></i>
                        </div>
                        <h3>{t('care.dailyCareTitle')}</h3>
                        <p>{t('care.dailyCareText')}</p>
                    </div>

                    {/* Cleaning */}
                    <div className="care-instruction-card">
                        <div className="care-instruction-icon">
                            <i className="fas fa-tint"></i>
                        </div>
                        <h3>{t('care.cleaningTitle')}</h3>
                        <p>{t('care.cleaningText')}</p>
                    </div>

                    {/* Storage */}
                    <div className="care-instruction-card">
                        <div className="care-instruction-icon">
                            <i className="fas fa-archive"></i>
                        </div>
                        <h3>{t('care.storageTitle')}</h3>
                        <p>{t('care.storageText')}</p>
                    </div>

                    {/* Protection */}
                    <div className="care-instruction-card">
                        <div className="care-instruction-icon">
                            <i className="fas fa-shield-alt"></i>
                        </div>
                        <h3>{t('care.protectionTitle')}</h3>
                        <p>{t('care.protectionText')}</p>
                    </div>
                </div>
            </section>

            {/* FAQ Section */}
            <section className="care-faq">
                <h2>{t('care.faqTitle')}</h2>
                
                <div className="care-faq-list">
                    <div className="care-faq-item">
                        <h3>{t('care.faq1Question')}</h3>
                        <p>{t('care.faq1Answer')}</p>
                    </div>
                    
                    <div className="care-faq-item">
                        <h3>{t('care.faq2Question')}</h3>
                        <p>{t('care.faq2Answer')}</p>
                    </div>
                    
                    <div className="care-faq-item">
                        <h3>{t('care.faq3Question')}</h3>
                        <p>{t('care.faq3Answer')}</p>
                    </div>
                    
                    <div className="care-faq-item">
                        <h3>{t('care.faq4Question')}</h3>
                        <p>{t('care.faq4Answer')}</p>
                    </div>
                </div>
            </section>
            
            {/* Contact Section */}
            <section className="care-contact">
                <div className="care-contact-content">
                    <h2>{t('care.contactTitle')}</h2>
                    <p>{t('care.contactText')}</p>
                    <a href="https://www.instagram.com/selezium/" 
                       className="care-contact-btn"
                       target="_blank"
                       rel="noopener noreferrer">
                        {t('care.contactBtn')}
                    </a>
                </div>
            </section>
        </div>
    );
} 